import { render } from "./Dashboard.vue?vue&type=template&id=683bb4f7&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=683bb4f7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683bb4f7"]])

export default __exports__